import { mapGetters } from 'vuex'

import './style.scss'

export default {
  name: 'Burger',
  methods: {
    toggleMenu () {
      this.$store.dispatch('toggleMenu')
    }
  },
  computed: {
    ...mapGetters(['menuOpen'])
  },
  render (h) {
    const { menuOpen, toggleMenu } = this
    return (
      <button type='button' class={'Burger' + (menuOpen ? ' is-open' : '')} onClick={toggleMenu.bind()} aria-label='Open Menu'>
        <div class='Burger__burger'>
        </div>
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Burger/index.js